module.exports = __webpack_public_path__ + "img/UTDEAD.46f66ef7.png";